// extracted by mini-css-extract-plugin
var _1 = "AppointmentFormModalParticipantTag-modulenoEmail__TzsxL";
export { _1 as "noEmail" }
